<div id="form-preview">
    <div class="subtitle-help-text">
        <p *ngIf="!settings" i18n>The below shows how the form will display to users. Please select a state and a role.</p>
        <p *ngIf="settings" i18n>The below shows how the form will display to {{ settingsRole.name }} in the state {{ settingsState.name }}</p>
    </div>
    <form id="settingsForm" [formGroup]="settingsForm">
        <fieldset>
            <mat-form-field appearance="outline">
                <mat-label i18n>STATE</mat-label>
                <mat-select formControlName="state">
                    <mat-option *ngFor="let state of states" [value]="state.id">{{ state.name }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label i18n>ROLE</mat-label>
                <mat-select formControlName="role">
                    <mat-optgroup *ngFor="let group of settingsRolesData" [label]="group.name">
                        <mat-option *ngFor="let role of group.items" [value]="role.id">
                            {{ role.name }}
                        </mat-option>
                    </mat-optgroup>
                </mat-select>
            </mat-form-field>
        </fieldset>
    </form>

    <div *ngIf="shouldShowBulkAssingButtons" class="text-center mt-5">
        <p><strong i18n>No fields have been assigned for the selected state and role.</strong></p>
        <p i18n>You can choose which fields appear on the form by assigning them individually from the list of fields, or assign them all using the buttons below.</p>
        <div class="we-flex we-flex-row we-justify-center we-gap-1">
            <button mat-flat-button
                    color="primary"
                    type="button"
                    (click)="onSetPermissionForAllFields(false)"
                    i18n>Add ALL fields as READ-ONLY</button>
            <button mat-flat-button
                    color="primary"
                    type="button"
                    (click)="onSetPermissionForAllFields(true)"
                    i18n>Add ALL fields as EDITABLE</button>
        </div>
    </div>

    <div *ngIf="error">
      <p class="text-center"><strong i18n>Unable to show the form preview for selected combination due to an unexpected error.</strong></p>
      <p class="small pl-5 pr-5">{{ error.toString()}}</p>
    </div>

    <mat-card appearance="outlined" *ngIf="isPreviewAvailable" class="mt-5">
        <form [formGroup]="previewForm.control">
            <eas-easform-group [easGroup]="previewForm" [forceDisplayReadOnly]="true"></eas-easform-group>
            <div class="we-flex we-flex-row we-justify-center we-gap-1">
                <button mat-flat-button
                        type="button"
                        *ngFor="let transition of easBuilderState.transitions$ | async"
                        [disabled]="true">{{ transition.name }}</button>
            </div>
        </form>
    </mat-card>
</div>
